import apiService from '../../../services/apiService';

const RETREAT_API = '/ykrestapi/CampChannel';

export const retreatService = {
  // Get all centers
  getCenters: async (countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetCenterForRetreat`, {
        Country_Desc: countryDesc,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching centers:', error);
      throw error;
    }
  },

  // Get camps by center
  getCampsByCenter: async (centerId, countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetCamp`, {
        Camp_Id: 0,
        Center_Id: parseInt(centerId),
        Camp_Name: '',
        Camp_Description: '',
        Camp_Fee: 0,
        Camp_Date_To: new Date().toISOString(),
        Camp_Date_From: new Date().toISOString(),
        Camp_Image_Url: '',
        Camp_Type: 'R',
        App_Id: 1,
        Organization_Id: 0,
        Country_Desc: countryDesc,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching camps:', error);
      throw error;
    }
  },

  // Get accommodation fee and camp date
  getAccommodationAndCampDate: async (campData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetAccommodationFeeAndCampDate`, campData);
      return response.data;
    } catch (error) {
      console.error('Error fetching accommodation and camp date:', error);
      throw error;
    }
  },

  // Add retreat registration
  addRetreatRegistration: async (registrationData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/AddRetreatRegistration`, registrationData);
      return response.data;
    } catch (error) {
      console.error('Error adding retreat registration:', error);
      throw error;
    }
  },

  // Add retreat registration detail
  addRetreatRegistrationDetail: async (detailData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/AddRetreatRegistrationDetail`, detailData);
      return response.data;
    } catch (error) {
      console.error('Error adding retreat registration detail:', error);
      throw error;
    }
  },

  // Get retreat calculation
  getRetreatCalculation: async (registeredData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetRetreatCalculation`, registeredData);
      return response.data;
    } catch (error) {
      console.error('Error fetching retreat calculation:', error);
      throw error;
    }
  },

  // Update payment status
  updatePaymentStatus: async (paymentData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/UpdatePaymentStatus`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  },

  // Get enrolled students
  getEnrolledStudents: async (paymentData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetRetreatEnrolledStudents`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled students:', error);
      throw error;
    }
  },

  // Get user registration details
  getUserRegistrationDetails: async (userId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetUserRegistrationDetails`, {
        userId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user registration details:', error);
      throw error;
    }
  },

  // Update user details
  updateUserDetails: async (userDetails) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/UpdateUserDetail`, userDetails);
      return response.data;
    } catch (error) {
      console.error('Error updating user details:', error);
      throw error;
    }
  },
};

export default retreatService;
